import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const StepContainer = styled.div<{ token: GlobalToken } & { $isOpen?: boolean }>`
  width: 100%;
  max-width: ${({ token }) => token.screenLG}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;
  color: ${({ token }) => token.colorText};
  position: relative;
  margin-left: 0;

  .customer-information-step-form,
  .expanded-customer-information-step-form {
    width: 100%;
  }

  .collapsible-section {
    width: 100%;
    margin-bottom: ${({ token }) => token.marginLG}px;
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    align-self: flex-start;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
  }

  .customer-information-step-form {
    padding: ${({ theme: { token } }) => token.paddingLG}px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    .collapsed-customer-information-step-form {
      width: 100%;
    }

    .form-header,
    .customer-name {
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
      width: 100%;
    }

    .form-header {
      margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
      color: ${({ theme: { token } }) => token.colorPrimaryText};
    }

    .customer-name {
      margin-bottom: ${({ theme: { token } }) => token.margin}px;
    }

    .account-id-wrapper {
      display: flex;
      flex: 1;
    }

    .account-id-label {
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      margin-right: ${({ theme: { token } }) => token.marginXS}px;
    }

    .tier-tag {
      margin-left: ${({ theme: { token } }) => token.marginXS}px;
      padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
      border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
      background-color: ${({ theme: { token } }) => token.colorPrimaryBg};
      color: ${({ theme: { token } }) => token.colorPrimary};
    }
  }

  .toggle-button {
    position: absolute;
    top: ${({ token }) => token.margin}px;
    right: ${({ token }) => token.paddingLG}px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ token }) => token.paddingLG}px;
    height: ${({ token }) => token.paddingLG}px;
    z-index: 10;
  }

  .arrow-icon-container {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
    transition: transform 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .collapsible-content-container {
    max-height: ${({ $isOpen }) => ($isOpen ? '3000px' : '0')};
    width: 100%;
    overflow: hidden;
    transition: max-height 0.6s ease-in-out;
  }
`;
